/**
 * Collection 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  noMore: 'No more ~',
  loading: 'Loading...',
} as const
